<template>
    <div :class="rootClasses">
        <div class="avail-full-calendar__body">
            <month-calendar
                v-if="selectedCalendarOption === 'Month'"
                :year="year"
                :month="month"
                :dates="dates"
                :physician="physician"
                :practice="practice"
                :showCancelled="showCancelled"
                @emitEvent="emitEvent($event)"
            ></month-calendar>
            <week-calendar
                v-else-if="selectedCalendarOption === 'Week'"
                :year="year"
                :month="month"
                :dates="dates"
                :physician="physician"
                :practice="practice"
                :showCancelled="showCancelled"
                @emitEvent="emitEvent($event)"
            ></week-calendar>
            <day-calendar
                v-else
                :year="year"
                :month="month"
                :dates="dates"
                :physician="physician"
                :practice="practice"
                :showCancelled="showCancelled"
                @emitEvent="emitEvent($event)"
            ></day-calendar>
            <div v-if="loading" class="avail-full-calendar__loading" aria-hidden="true">
                <div class="avail-full-calendar__spinner"></div>
            </div>
        </div>
    </div>
</template>

<script>
    import DayCalendar from './AvailabilityDayCalendar'
    import WeekCalendar from './AvailabilityWeekCalendar'
    import MonthCalendar from './AvailabilityMonthCalendar'

    export default {
        components: {
            DayCalendar,
            WeekCalendar,
            MonthCalendar,
        },

        props: {
            year: { type: Number, required: true },
            month: { type: Number, required: true },
            dates: { type: Object, required: true },
            physician: { type: Object, required: true },
            practice: { type: Object, required: true },
            showCancelled: { type: Boolean, required: true },
            loading: { type: Boolean, default: false },
        },

        computed: {
            rootClasses() {
                return {
                    'avail-full-calendar': true,
                    'avail-full-calendar--loading': this.loading,
                }
            },

            selectedCalendarOption() {
                const viewMap = { monthly: 'Month', weekly: 'Week', daily: 'Day' }
                return viewMap[this.$route.query.view] || 'Month'
            },
        },
    }
</script>

<style scoped>
    .avail-full-calendar {
        width: 100%;
        padding: 0 24px 32px;
        box-sizing: border-box;
    }

    .avail-full-calendar__body {
        width: 100%;
        position: relative;
    }

    .avail-full-calendar--loading .avail-full-calendar__body {
        pointer-events: none;
    }

    .avail-full-calendar__loading {
        position: absolute;
        inset: 0;
        display: flex;
        align-items: flex-start;
        justify-content: center;
        padding-top: 80px;
        background: rgba(255, 255, 255, 0.55);
        z-index: 5;
    }

    .avail-full-calendar__spinner {
        width: 28px;
        height: 28px;
        border: 2.5px solid #e5e7eb;
        border-top-color: #6366f1;
        border-radius: 50%;
        animation: avail-spin 0.8s linear infinite;
    }

    @keyframes avail-spin {
        to {
            transform: rotate(360deg);
        }
    }

    @media (max-width: 768px) {
        .avail-full-calendar {
            padding: 0 12px 24px;
        }
    }

    @media (max-width: 425px) {
        .avail-full-calendar {
            padding: 0 8px 16px;
        }
    }
</style>
